import { USER_ROLE } from '~/shared/constants';
import type { NavigationPolicyContext } from '~/shared/permissions/types';
import type { ShortUserType } from '~/types';

import { hasRole } from '../helpers/has-role';
import { P } from '../permissions';

export function canNavigation(
  user: ShortUserType | null,
  permission: string,
  _ctx: NavigationPolicyContext = {},
): boolean {
  if (!user?.role) {
    return false;
  }

  switch (permission) {
    case P.WEB_PROFILE_VIEW:
      return hasRole(user.role, [
        USER_ROLE.USER,
        USER_ROLE.STUDENT,
        USER_ROLE.TEACHER,
        USER_ROLE.SUPER_TEACHER,
        USER_ROLE.MANAGER,
        USER_ROLE.AUTHOR,
        USER_ROLE.ADMIN,
      ]);

    case P.WEB_DIALOGS_VIEW:
      return hasRole(user.role, [
        USER_ROLE.USER,
        USER_ROLE.STUDENT,
        USER_ROLE.TEACHER,
        USER_ROLE.SUPER_TEACHER,
        USER_ROLE.MANAGER,
        USER_ROLE.AUTHOR,
        USER_ROLE.ADMIN,
      ]);

    case P.PLATFORM_PROFILE_VIEW:
      return hasRole(user.role, [
        USER_ROLE.STUDENT,
        USER_ROLE.TEACHER,
        USER_ROLE.SUPER_TEACHER,
        USER_ROLE.MANAGER,
        USER_ROLE.ADMIN,
      ]);

    case P.PLATFORM_DIALOGS_VIEW:
      return hasRole(user.role, [
        USER_ROLE.STUDENT,
        USER_ROLE.TEACHER,
        USER_ROLE.SUPER_TEACHER,
        USER_ROLE.MANAGER,
        USER_ROLE.ADMIN,
      ]);

    case P.PLATFORM_COURSES_VIEW:
      return hasRole(user.role, [USER_ROLE.STUDENT, USER_ROLE.TEACHER, USER_ROLE.SUPER_TEACHER]);

    case P.PLATFORM_VIDEO_COURSES_VIEW:
      return hasRole(user.role, [USER_ROLE.STUDENT, USER_ROLE.TEACHER, USER_ROLE.SUPER_TEACHER]);

    case P.PLATFORM_STUDENTS_BOARD_VIEW:
      return hasRole(user.role, [USER_ROLE.TEACHER, USER_ROLE.SUPER_TEACHER]);

    case P.PLATFORM_STUDENTS_LIST_VIEW:
      return hasRole(user.role, [USER_ROLE.MANAGER, USER_ROLE.TEACHER, USER_ROLE.SUPER_TEACHER]);

    case P.ADMIN_PROFILE_VIEW:
      return hasRole(user.role, [USER_ROLE.ADMIN]);

    case P.ADMIN_DIALOGS_VIEW:
      return hasRole(user.role, [USER_ROLE.ADMIN]);

    case P.ADMIN_PANEL_VIEW:
      return hasRole(user.role, [USER_ROLE.ADMIN]);

    default:
      return false;
  }
}
